<!-- 注册 -->
<template>
  <div class="box" style="width: 100%;height: 100%;">
    <div class="login-titles">
      <span style="color: #212020">账号注册</span>
      <span style="float: right; ">已有账号？<span style="color: red" @click="loginto">直接登录</span></span>
    </div>

    <!-- 账号登录 -->
    <el-form class="logina" :model="ruleForm" :rules="rules" ref="ruleForm">
      <el-form-item class="login-row" prop="receiveNo">
        <el-input v-model="ruleForm.receiveNo" placeholder="手机号" @blur="testItem" />
      </el-form-item>
      <el-form-item label="验证" prop="isLock" v-if="slideShow ? true : false">
        <sliderVerifyCode v-model="ruleForm.isLock" @change="handlerLock"></sliderVerifyCode>
      </el-form-item>

      <el-form-item class="login-row" prop="control">
        <el-input type="password" style="width: 70%" v-model="ruleForm.control" placeholder="短信验证码" />
        <el-button size="small" type="button" :disabled="btnShow ? false : true" style="float: right" class="btn btn-info"
          id="send" @click="getCode(ruleForm)">
          <span v-show="count_show">发送验证码</span>
          <span v-show="!count_show" class="count">{{ count }} </span>
        </el-button>
      </el-form-item>
      <el-form-item class="login-row" prop="pwd">
        <el-input type="password" v-model="ruleForm.pwd" placeholder="密码" />
      </el-form-item>
      <el-form-item class="login-row" prop="againpwd">
        <el-input :type="showPwd ? 'text' : 'password'" style="width: 85%" v-model="ruleForm.againpwd"
          placeholder="确认密码" />
        <img v-show="!showPwd" src="../imgs/eye-no.svg" @click="showPwd = true" class="eye-icon" />
        <img v-show="showPwd" src="../imgs/eye.svg" @click="showPwd = false" class="eye-icon" />
      </el-form-item>

      <el-form-item class="forget">
        <el-checkbox v-model="checked">我已同意并愿意准守 <a href="">《用户协议》</a></el-checkbox>
      </el-form-item>
      <el-button
        :disabled="ruleForm.receiveNo && ruleForm.control && ruleForm.againpwd && checked && (ruleForm.pwd == ruleForm.againpwd) ? false : true"
        class="login-bttn" @click="login">立即注册</el-button>

      <!-- <div v-else class="login-bttn disabled">立即登录</div> -->
    </el-form>
    <!-- 验证码登录 -->
  </div>
</template>
<script>
import sliderVerifyCode from "@/components/slider-verify-code.vue";
export default {
  name: "registerLogin",
  components: { sliderVerifyCode },
  data() {
    //const count = 60;  倒计时的时间
    const checkStatus = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请按住滑块，拖动到最右边"));
      } else {
        if (
          this.ruleForm.receiveNo == "" || !this.ruleForm.receiveNo
        ) {
          setTimeout(() => {
            this.ruleForm.isLock = false;
            this.$refs.ruleForm.validateField("receiveNo");
            // this.$refs.form.validateField("pass");
            return callback(new Error("验证未通过"));
          }, 1);
        }
        callback();
      }
    };

    // 手机号码验证
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("手机号不能为空！"));
      }
      //使用正则表达式进行验证手机号码
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("手机号不正确！"));
      }
      callback();
      return validatePhone.value;
    };

    // 密码是否一致
    const validatePwd = (rule, value, callback) => {
      if (!value) {
        callback(new Error("不能为空！"));
      }
      //使用正则表达式进行验证手机号码
      console.log(validatePhone.value);

      if (value != this.ruleForm.pwd) {
        callback(new Error("两次输入密码不一致！"));
        console.log(validatePhone.value);
      }
      callback();
    };

    // 密码格式是否正确
    const validatePsdReg = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入密码"));
      }
      if (!/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){6,20}$/.test(value)
      ) {
        callback(
          new Error(
            "请输入6-20位英文字母、数字或者符号（除空格），且字母、数字和标点符号至少包含两种"
          )
        );
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        receiveNo: "",
        pwd: "",
        control: "",
        againpwd: "",
      },
      slideShow: false,
      btnShow: false,
      showPwd: false,
      checked: "",
      telphone: "",
      name: "",
      form: {},
      count: 1,
      count_show: true,
      rules: {
        isLock: [{ validator: checkStatus, trigger: "blur" }],
        control: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        pwd: [
          {
            required: true,
            validator: validatePsdReg,
            trigger: "blur",
          },
        ],
        receiveNo: [
          { required: true, validator: validatePhone, trigger: "blur" },
        ],
        againpwd: [{ required: true, validator: validatePwd, trigger: "blur" }],
      },
    };
  },
  methods: {
    // 登录
    login() {
      this.$axios
        .post(`/weiXin/mobileRegistration?telphone=${this.ruleForm.receiveNo}&code=${this.ruleForm.control}&password=${this.ruleForm.againpwd}`)
        .then((res) => {
          console.log(res);
          console.log(res.code);
          if (!res.success) {
            this.$message.error(res.msg);
          } else {
            this.$message({
              message: '注册' + res.msg + '，请登录',
              type: "success",
            });
            //             var timer1=window.setTimeout(function(

            //             ){},1000);
            // var timer2=window.setInterval(function(){},1000);
            // window.clearTimeout(timer1)
            // window.clearInterval(timer2)
            setTimeout(() => {
              return window.location.href = '/login'
            }, 2000);


          }
        })
        .catch((err) => {
          alert(err)
          console.log(err);
        });
    },
    // 验证用户是否注册
    async testItem() {
      // console.log('okkkkk')
      this.telphone = this.ruleForm.receiveNo
      if (!/^1[3456789]\d{9}$/.test(this.telphone)) {
        return false;
      }
      // this.$axios.get(`/weiXin/existenceTel?telphone=${this.telphone}`)
      //   .then((res) => {
      //     console.log(res);
      //     if (!res.success) {
      //       console.log('用户未注册')
      //       this.slideShow = true
      //     } else {
      //       this.$message.error('用户' + res.data);
      //     }
      //   })
      //   .catch((err) => {
      //     // alert(err)
      //     this.slideShow = true
      //     console.log(err);
      //   });

      const res = await this.$axios.get(`/weiXin/existenceTel?telphone=${this.telphone}`)
      console.log(res);
      if (res.success) {
        // console.log('用户未注册')
        this.slideShow = true
      } else {
        this.$message.error('用户' + res.msg);
      }

    },
    // 发送短信验证码
    getCode() {
      this.count = 60; //倒计时时间
      this.count_show = false; //控制倒计时显示隐藏
      var reg_tel = /^(13[0-9]|14[01456789]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-3509])\d{8}$/;
      if (this.ruleForm.receiveNo == '') {
        alert('请填写手机号!');
        return false;
      } else if (!reg_tel.test(this.ruleForm.receiveNo)) {
        alert('请填写正确的手机号!');
        return false;
      }
      console.log(this.ruleForm.receiveNo);
      let params = {
        telphone: this.ruleForm.receiveNo
      };
      this.$axios.get('/weiXin/getCode', { params }).then(res => {
        this.btnShow = false
        console.log(res);
      })
      this.timer = setInterval(() => {
        if (this.count > 0) {
          this.count--;
        } else {
          clearInterval(this.timer);
          this.count_show = true;
          this.btnShow = true;
        }
      }, 1000);
    },
    // 滑块
    handlerLock(data) {
      if (data) {
        this.$refs.ruleForm.validateField("isLock");
      }
      this.btnShow = true;
    },
    // 登录
    loginto() {
      let that = this;
      that.twoShow = true;
      this.$emit("loginto", that.twoShow);
      // that.loginShow = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.box {
  padding: 30px;
}

.logina {
  width: 100%;
  padding: 50px 0;
}

.login-titles {
  // padding: 0 50px 0px;
  color: #b2b2b2;
  margin-top: 20px;
}

.codeShow:visited {
  text-decoration: none;
}

.login-row {
  /* margin-top: 78px; */
  width: 100%;
  border-bottom: 1px solid #e5e5e5;
  margin-top: 8px;
}

.login-row input {
  font-size: 18px;
  outline: none;
  border: none;
  flex: 1;
  height: 22px;
}

.login-row>>>.el-input__inner {
  font-size: 14px;
  outline: none;
  border: none;
  flex: 1;
  height: 22px;
  width: 100%;
}

.login-row .eye-icon {
  width: 24px;
  height: 20px;
  object-fit: contain;
  cursor: pointer;
}

.forget {
  font-size: 14px;
  float: right;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 0px;
  color: #999999;
}

.login-bttn {
  width: 100%;
  height: 56px;
  background-color: #db3a3b !important;
  margin-top: 60px;
  display: flex;
  border-radius: 6px;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #ffffff !important;
  cursor: pointer;

  &:hover {
    background-color: #db3a3b !important;
    color: #ffffff !important;
  }
}

.login-bttn.disabled {
  background-color: #db3a3b;
  cursor: not-allowed;
}

.login-logon {
  font-size: 14px;
  margin: 10px 130px;
}
</style>




// WEBPACK FOOTER //
// src/components/registerLogin.vue